<template>
    <div class="container mx-auto px-5">
        
        <h4 class="mt-3 text-1xl font-semibold">Frequently Asked Questions</h4>

        <div class="mt-5 border-slate-500 pb-2" style="border-bottom: .7px solid" v-for="(item, index) in data" v-bind:key="item.id">
            <p v-on:click="showAnswer(index)" class="text-regular hover:text-blue-700 cursor-pointer"> 
            <span class="">{{item.question}}</span></p>
            <p class="text-italic text-sm italic pl-5 pt-2 text-regular" v-if="item.show">{{item.answer}}</p>
        </div>

    </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
@Component({
  components: {
  },
})
export default class FAQ extends Vue {
    
    private data = [
 {
   "question": "What is the first step to clear imported cargo from Port?",
   "answer": "All customers are required to register themselves on the MPL Customer Portal (www.my.port.mv) prior to using the Port’s services.",
   "show": false
 },
 {
   "question": "How do you register on MPL’s Customer Portal?",
   "answer": "Registration can be completed via MyBandharu Portal registration page at https://my.port.mv/register . You can apply for registration either as an individual, a Company/Business Entity or a clearing agent.",
   "show": false
 },
 {
   "question": "Which documents do I have to submit in order to complete registration?",
   "answer": "To register as an individual, you will need to submit national identity card (NIC) copy. Companies are required to submit a copy of the Company’s registration. Clearing agents must submit the NIC copy if applying as an individual, or they may submit the business registration should they choose to apply as a business entity.",
   "show": false
 },
 {
   "question": "How does my registration application get approved?",
   "answer": "Once MPL receive customers request for registration, the information and attached documents will be verified and approved accordingly. After the company approves the registration, you will receive login details to the provided email address at registration. Your registration request will be processed and approved within 24hrs.",
   "show": false
 },
 {
   "question": "What can I do if the registration process is delayed?",
   "answer": "You can call +960 3039-308 directly to inform us of any issues in the registration process; this would help us to address your specific concerns.",
   "show": false
 },
 {
   "question": "How do I reset a forgotten password?",
   "answer": "Enter the “Forgot Password” option from login screen and you will be directed to provide your registered email address in order to obtain the reset link.",
   "show": false
 },
 {
   "question": "How do I change the registered email address provided during registration?",
   "answer": "You will be required to submit your NID copy in order to prove that you are the owner of the existing user. Alternatively, you can also change registered email address via a phone call, provided that we can verify whether you are the owner of the respective account. Any documentary proof required for verifications must be sent to ccd@port.mv and for direct assistance call +960 3039-308",
   "show": false
 },
 {
   "question": "How do I request container shifting at the Port for containerized cargo?",
   "answer": "MPL will pre-determine a fixed number of open slots to clear containerized cargo, made available via the MyBandharu Customer Portal. Consignees are then required to request in advance via MyBandharu Portal for Normal or Express Shifting.",
   "show": false
 },
 {
   "question": "How do I request container shifting at the Port for conventional cargo?",
   "answer": "It is not required to request a date in advance for clearing conventional or perishable cargo. You must inform the date on which you wish to clear the cargo via MyBandharu Portal in order for the cargo clearance department to start the process.",
   "show": false
 },
 {
   "question": "What is normal shifting service?",
   "answer": "Under normal shifting services, your cargo is moved in the order of container shifting request queue. You are required to request for the service three (3) days in advance for the application to be processed.",
   "show": false
 },
 {
   "question": "What is ‘normal-express shifting’ service and what is the process for application?",
   "answer": "If you have cargo which needs to be cleared urgently, you can request for Normal Express shifting. The service must be applied 2 days in advance for the process to start, via MyBandharu portal.",
   "show": false
 },
 {
   "question": "What is a daily-express shifting service?",
   "answer": "Daily Express Shifting is reserved for customers who requires urgent same-day shifting services. This service is available every day, except Fridays and Port holidays. You can apply for the daily-express shifting service via MyBandharu online portal.",
   "show": false
 },
 {
   "question": "How many free days are allowed at MPL for storage before clearance?",
   "answer": "Free day or hours allowed will depend on the type of cargo. The day on which cargo is unloaded at the port is excluded from the free-storage period.",
   "show": false
 },
 {
   "question": "What should we do if there are issues with the Bill of Lading (B/L)?",
   "answer": "Due to various reasons stemming from technical or process issues, the B/L might not be visible in the MyBandharu Portal. For example, the B/L might not be approved due to errors during its submission by the clearing agents. In such cases, directly contact our Data Processing Unit (DPU) by email dpu@port.mv or call 3322355.",
   "show": false
 },
 {
   "question": "What is the process required by the customer to change Common Berthing Mechanism (CBM)?",
   "answer": "Customers can directly contact our Data Processing Unit (DPU) by email dpu@port.mv or call 3322355 to request a change.",
   "show": false
 },
 {
   "question": "How do I check storage fees?",
   "answer": "Storage fees can be checked by contacting the Clearance Department by email clearance@port.mv. Alternatively, you can directly contact Data Processing Unit (DPU) by email dpu@port.mv or call DPU directly on +960-3322355.",
   "show": false
 }
]

    showAnswer(id: number) {
        if(this.data[id].show === false) {
            this.data[id].show = true;
        } else {
            this.data[id].show = false;
        }
    }

}
</script>
